import React from 'react';
import { ValidationTasks } from './ValidationTasks';
import ValidationInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: '300px',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Base Validator',
        dataIndex: 'base_validator__name',
        key: 'base_validator',
        sorter: false,
        render: (text, record) => record.base_validator.name
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the validation
          {' '}
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    // General
    title: 'Validations'
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Validation',
    defaultKey: '0',
    title: 'Validation',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <ValidationInput
            {...props}
            title="Validation"
          />
        ),
        forceRender: true
      },
      {
        key: 1,
        title: 'Runs',
        component: props => (
          <ValidationTasks
            {...props}
            title="Tasks"
          />
        )
      }
    ]
  }
};

export default config;
